<app-breadcrumb [title]="'Listado'" [items]="['Mantenimiento']" [active_item]="'Listado'">
</app-breadcrumb>

<div class="card">
  <div class="card-header d-flex align-items-center bg-primary text-white">
    <i class="icofont icofont-verification-check me-2"></i>
    <h5 class="mb-0"><strong>CONSULTA DE COMBUSTIBLE</strong></h5>
  </div>

  <div class="card-body">
    <form [formGroup]="formTanqueo">
      <div class="row g-3">
        <div class="col-md-4">
          <label class="form-label" for="vehiculos"><strong>Placa</strong> *:</label>
          <ng-select id="vehiculos" [items]="vehiculos" bindLabel="placa" bindValue="placa" formControlName="placa"
            placeholder="Selecciona una opción" class="js-example-placeholder-multiple">
          </ng-select>
        </div>

        <div class="col-md-4">
          <label class="form-label" for="fecha"><strong>Fecha Inicial</strong>:</label>
          <div class="input-group input-group-sm">
            <input id="fecha" type="date" formControlName="fecha" class="form-control form-control-lg fs-14"
              name="fecha" (change)="actualizarMinFechaFinal()" [max]="hoy" onkeydown="return false;"/>
          </div>
        </div>

        <div class="col-md-4">
          <label class="form-label" for="fechaFinal"><strong>Fecha de Finalización</strong>:</label>
          <div class="input-group input-group-sm">
            <input id="fechaFinal" type="date" formControlName="fechaFinal" class="form-control form-control-lg fs-14"
              name="fechaFinal" [min]="minFechaFinal" [max]="hoy" onkeydown="return false;" />
          </div>
        </div>

      </div>

    </form>
    <div class="card card-absolute border border-primary rounded my-5">
      <div class="card-header bg-primary">
        <h5 class="text-white"><strong>FILTROS RÁPIDOS</strong></h5>
      </div>
      <div class="card-body">
        <div class="row g-3 mb-3">
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-primary btn-sm w-100" (click)="seleccionarRango('dia')"><strong>AYER</strong></button>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-primary btn-sm w-100"
              (click)="seleccionarRango('semana')"><strong>ÚLTIMA SEMANA</strong></button>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-primary btn-sm w-100"
              (click)="seleccionarRango('mes')"><strong>MES</strong></button>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-primary btn-sm w-100"
              (click)="seleccionarRango('trimestre')"><strong>TRIMESTRE</strong></button>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-primary btn-sm w-100"
              (click)="seleccionarRango('semestre')"><strong>SEMESTRE</strong></button>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-primary btn-sm w-100"
              (click)="seleccionarRango('anio')"><strong>AÑO</strong></button>
          </div>

        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center gap-3 mt-3">
      <button class="btn btn-primary d-flex align-items-center" type="button" (click)="buscarTanqueos()">
        Consultar
      </button>
    </div>

  </div>
</div>

<div class="card height-equal" *ngIf="mostrarTabla">
  <div class="card-header card-no-border">
    <div class="header-top">
      <h5 class="m-0"><strong>HISTORIAL TANQUEOS</strong></h5>
      <div class="card-header-right-icon">
        <div class="dropdown">
          <button class="btn dropdown-toggle" type="button" (click)="toggle()"><strong>Ficha</strong></button>
          <div class="dropdown-menu dropdown-menu-end" [class.show]="show">
            <a class="dropdown-item" href="javascript:void(0)" (click)="ExportaHV(
                resultadosTanqueos[0]?.placa,
                resultadosTanqueos[0]?.vehiculo?.marcas?.marca,
                resultadosTanqueos[0]?.vehiculo?.modelo,
                resultadosTanqueos[0]?.vehiculo?.nombreEmpresa?.nombre,
                resultadosTanqueos[0]?.vehiculo?.tipoVehiculo?.tipos,
                resultadosTanqueos[0]?.vehiculo?.color,
                resultadosTanqueos[0]?.vehiculo?.matricula,
                resultadosTanqueos[0]?.vehiculo?.fechalict,
                resultadosTanqueos[0]?.vehiculo?.cilindraje,
                resultadosTanqueos[0]?.vehiculo?.motor,
                resultadosTanqueos[0]?.vehiculo?.serie,
                resultadosTanqueos[0]?.vehiculo?.linea,
                resultadosTanqueos[0]?.vehiculo?.organismo,
                resultadosTanqueos[0]?.vehiculo?.tipoServicio?.Descripcion,
                resultadosTanqueos[0]?.vehiculo?.capacidad,
                resultadosTanqueos[0]?.vehiculo?.chasis,
              
                filteredTanqueos
              )">
              <strong>Listado de Tanqueos</strong>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

<div class="card-body pt-0">

  <!-- Lista de actividades o mensaje si no hay datos -->
  <ul *ngIf="paginatedActivity.length > 0; else sinDatos" class="activity-timeline">
    <li class="d-flex position-relative mb-4" *ngFor="let item of paginatedActivity">
      <div class="me-2 d-flex flex-column align-items-center pt-1">
        <i class="fa fa-calendar mb-3"></i>
        <i class="fa fa-filter mb-3"></i>
        <i class="fa fa-money"></i>
      </div>
      <div class="activity-dot-{{item.primaryDotColor}}"></div>
      <div class="w-100 ms-3">
        <p class="d-flex justify-content-between mb-2">
          <span class="date-content light-background">{{ item.date }}</span>
        </p>
        <h6>{{ item.title }}<span class="dot-notification"></span></h6>
        <p class="f-light">{{ item.dace }}</p>
      </div>
    </li>
  </ul>

  <!-- Template para mostrar cuando no hay datos -->
<ng-template #sinDatos>
  <div class="texto-vacio text-warning">
    {{ mensajeBusqueda || 'No hay datos de tanqueos para mostrar.' }}
  </div>
</ng-template>

  <!-- Navegación entre páginas -->
  <div class="d-flex justify-content-center mt-3" *ngIf="totalPages > 1">
    <button class="btn btn-sm btn-primary me-2" (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">
      <strong>Anterior</strong>
    </button>
    <span class="align-self-center">Página {{ currentPage }} de {{ totalPages }}</span>
    <button class="btn btn-sm btn-primary ms-2" (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">
      <strong>Siguiente</strong>
    </button>
  </div>
  
</div>

</div>